'use client'

import { useMemo } from 'react'
import { Typography } from '@acko/typography'
import { ABHA_HERO_MODAL_PREPARE_STEP_DATA } from '@components/NewProduct/constants'
import { resolveAbhaHeroStepData } from '@components/NewProduct/AbhaHeroWidget/steps/abhaHeroStepData'

export type AbhaHeroPrepareStepContent = {
  imageSrc: string
  title: string
}

export type AbhaHeroPrepareStepProps = {
  data?: Record<string, unknown>
  isMobile: boolean
}

const PREPARE_STEP_DEFAULTS: AbhaHeroPrepareStepContent = {
  imageSrc: ABHA_HERO_MODAL_PREPARE_STEP_DATA.IMAGE_SRC,
  title: ABHA_HERO_MODAL_PREPARE_STEP_DATA.TITLE,
}

export const AbhaHeroPrepareStep = ({ data, isMobile }: AbhaHeroPrepareStepProps) => {
  const stepData = useMemo(
    () => resolveAbhaHeroStepData(data, isMobile, PREPARE_STEP_DEFAULTS),
    [data, isMobile],
  )

  return (
    <div className="abha-hero-modal__prepare">
      <div
        className="abha-hero-modal__prepare-image"
        role="img"
        aria-label="ABHA cards illustration"
        style={{ backgroundImage: `url(${stepData.imageSrc})` }}
      />
      <Typography
        as="p"
        scale="sm"
        emphasis="medium"
        color="brand"
        align="center"
        className="abha-hero-modal__prepare-title">
        {stepData.title}
      </Typography>
    </div>
  )
}
